export default `
// Worker code for calculating popular filter values
function getNestedValue(obj, path) {
    return path.split('.').reduce((current, key) => current?.[key], obj);
}

self.addEventListener('message', function({ data }) {
    // Validate input data
    if (!data) {
        console.error('[Suggestions Worker] No data received');
        self.postMessage({});
        return;
    }

    const items = data.data;
    const columns = data.columns;

    // Validate items and columns
    if (!items || !Array.isArray(items)) {
        console.error('[Suggestions Worker] Invalid items array:', items);
        self.postMessage({});
        return;
    }

    if (!columns || !Array.isArray(columns)) {
        console.error('[Suggestions Worker] Invalid columns array:', columns);
        self.postMessage({});
        return;
    }

    const suggestions = {};

    // For each column, calculate top-10 popular values
    columns.forEach(function(column) {
        // Count frequency of each value
        const frequencyMap = new Map();

        items.forEach(function(item) {
            let value;

            // Special handling for product_transport_mode (combined field)
            if (column === 'product_transport_mode') {
                const transportMode = getNestedValue(item, 'data.transport_mode');
                const product = getNestedValue(item, 'data.product');
                if (transportMode && product) {
                    value = transportMode + ':' + product;
                }
            } else {
                // Support nested properties like 'data.shipper_name'
                value = getNestedValue(item, column);
            }

            // Skip null/undefined/empty values
            if (value === null || value === undefined || value === '') {
                return;
            }

            // Convert to string for consistent handling
            const stringValue = String(value).trim();

            // Skip empty strings after trimming
            if (!stringValue) {
                return;
            }

            frequencyMap.set(stringValue, (frequencyMap.get(stringValue) || 0) + 1);
        });

        // Sort by frequency and take top-10
        const sortedValues = Array.from(frequencyMap.entries())
            .sort(function(a, b) { return b[1] - a[1]; }) // Sort descending by frequency
            .slice(0, 10) // Take top-10
            .map(function(entry) { return entry[0]; }); // Extract only values

        suggestions[column] = sortedValues;
    });

    self.postMessage(suggestions);
});
`;